/*
 * @Author: caiqin.xie
 * @since: 2023-06-28 15:26:50
 * @lastTime: 2023-11-07 09:55:09
 * @LastEditors: huangfuchunmei
 * @message: 服务支持-产品参数
 * @url: www.picoxr.com/cn/support/product-parameter
 */
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import ParameterTable from "./components/ParameterTable";
import styles from "./index.module.scss";
import request from '@/common/request'
import { DOMAIN_API, COUNTRY_HREFLANG, COUNTRY_LIST } from '@/common/const'
import { getFileExtension } from '@/common/untils'
import LazyMedia from "@/components/LazyMedia"

interface IParam {
  name: string;
  paramBOs: Record<string, string>[];
}

const ProductParameter = (props: any) => {
  const {ctry, words, data} = props.data
  const [paramsList, setParamsList] = useState<IParam[]>(data?.productParams || []) // 产品参数列表
  const [productCover, setProductCover] = useState<string>(data?.cover || "") // 产品封面
  const altName = data?.coverAlt // 产品封面alt

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support/product-parameter`} />
      ))
    )
  }
  return (
    <div>
      <Helmet>
        <title>{words?.support_product_parameter_seo_title}</title>
        <meta name="description" content={words?.support_product_parameter_seo_description} />
        <meta name="keywords" content={words?.support_product_parameter_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/support/product-parameter`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['product-wrap']}>
        <div className={styles["product-content-wrap"]}>
          <h1>{words?.support_product_parameter_title}</h1>
          {/* Product parameters */}
          <div className={styles["product-content"]}>
            <div className={styles["product-tab-content"]}>
              {/* 产品banner */}
              {productCover && <div className={styles['product-img']}>
                {(
                  getFileExtension(productCover) === 'mp4'
                  ? <LazyMedia type="video" loop autoPlay preload="auto" playsInline muted src={productCover}/>
                  : <LazyMedia type="image" src={productCover} alt={altName} />
                )}
              </div>}

              {/* 产品参数表 */}
              <ParameterTable ctry={ctry} words={words} paramsList={paramsList} />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit (ctry: string, pathName: string) {
  return new Promise((resolve, reject) => {
    const productId = pathName.split('/').pop()
    request.post(`${DOMAIN_API}/o/product/getMaintenance`, {
      stationCode: ctry,
      id: productId
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

ProductParameter.getInitialProps = (ctry: string, pathName: string) => {
  return getInit(ctry, pathName)
};
export default ProductParameter;
